import { ICreateInventoryCategoryResponse, IEditInventoryCategoryResponse, IInventoryCategoryPayload, InventoryCategoryListResponse } from "../../../features/inventoryManagement/category/types";
import ApiService from "../../ApiService";

enum InventoryEndpoints {
    URL = "/inventory-categories",
}

class InventoryCategoryService extends ApiService {
    async getCategories(params?: {
        page?: number;
        size?: number;
        name?: string;
        status?: number;
    }): Promise<InventoryCategoryListResponse> {
        const queryParams = new URLSearchParams();
        if (params?.page) queryParams.append("page", String(params.page));
        if (params?.size) queryParams.append("size", String(params.size));
        if (params?.name) queryParams.append("name", params.name);
        if (params?.status !== undefined)
            queryParams.append("status", String(params.status));

        const queryString = queryParams.toString();
        const url = `${InventoryEndpoints.URL}${queryString ? `?${queryString}` : ""}`;

        return this.get<InventoryCategoryListResponse>(url);
    }

    async saveOrUpdateInventoryCategory(
        payload: IInventoryCategoryPayload
    ): Promise<ICreateInventoryCategoryResponse> {
        if (payload.id) {
            // Update existing
            return this.put<ICreateInventoryCategoryResponse>(
                `${InventoryEndpoints.URL}/${payload.id}`,
                payload
            );
        }
        // Create new
        return this.post<ICreateInventoryCategoryResponse>(
            InventoryEndpoints.URL,
            payload
        );
    }

    async getEditInventoryCategory(id: number): Promise<IEditInventoryCategoryResponse> {
        return this.get<IEditInventoryCategoryResponse>(`${InventoryEndpoints.URL}/${id}`);
    }

}


export const inventoryCategoryService = new InventoryCategoryService();
